import { render } from "./UiDynamicProps.vue?vue&type=template&id=3b6b8649"
import script from "./UiDynamicProps.vue?vue&type=script&lang=js"
export * from "./UiDynamicProps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__